var render = function render(){var _vm=this,_c=_vm._self._c;return _c('asf-multi-form-wrapper',{attrs:{"default-form-id":_vm.defaultFormId,"forms":_vm.manualForms}})
}
var staticRenderFns = []

export { render, staticRenderFns }